export default "__VITE_ASSET__BrCnrfIy__"